var exports = {};
exports = {
  strings: {
    generatingThumbnails: "Generating thumbnails..."
  }
};
export default exports;